<div class="page-wrapper">
  <!-- <button routerLink="/tg-itinerrary-form" class="top-button">Plan Your Trip</button> -->
  <div class="content-wrapper">
    <img routerLink="/trip-details" src="assets/Images/tg-landing-page.png" alt="Long Image" class="long-image" />
  </div>
</div>